import type { PartialConfig } from './base';

const production: PartialConfig = {
  backend: {
    base: 'https://k8s.litlingo.com/api/v1',
  },
};

export default production;
